<div class="dasboard-width">
  <div class="row header mar-lft-rgt-0">
    <div class="col-md-6">Report - Trend with Bar Chart</div>
  </div>
  <div class="content mr-top-5 mar-lft-rgt-0">
    <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
    <div class="row content mr-top-5 mar-lft-rgt-0">
      <div class="col-md-3">
          <div class="form-group">
              <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedReportType"
                      (change)="onReportTypeChange($event.target.selectedIndex)">
                <option *ngFor="let reportType of reportTypeArray" [value]="reportType.type">{{reportType.view}}</option>
              </select>
          </div>
      </div>
      <div *ngIf="viewTicketType" class="col-md-3">
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedTicketType"
                    (change)="onChangeTicketType($event.target.selectedIndex)">
              <option *ngFor="let valueType of ticketTypeArray" [value]="valueType.id">{{valueType.name}}</option>
            </select>
        </div>
    </div>
      <div *ngIf="viewReportTypeValue" class="col-md-3">
          <div class="form-group">
              <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedReportTypeValue"
                      (change)="onReportTypeValueChange($event.target.selectedIndex)">
                <option *ngFor="let valueType of reportTypeValueArray" [value]="valueType.id">{{valueType.name}}</option>
              </select>
          </div>
      </div>
      <div class="col-md-3">
          <div class="form-group">
              <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedReportFilter"
                      (change)="onReportFilterChange($event.target.selectedIndex)">
                <option *ngFor="let reportFilter of reportFilterArray" [value]="reportFilter.type">{{reportFilter.view}}</option>
              </select>
          </div>
      </div>
      <div class="col-md-2">
          <button  type="button" class="btn btn-success radius-0" (click)="generateDashboardReport()">Submit</button>
      </div>
    </div>
    <div [hidden]="!viewReport" class="row mar-lft-rgt-0">
        <div class="col-12">
                <button  type="button" class="btn btn-success font-13 radius-0 float-right" (click)="exportAsPDF()">Export to PDF</button>
        </div>
    </div>
    
    <div class="row content mr-top-5 mar-lft-rgt-0" #reportBody (window:resize)="onResize($event)">
      <div class="col-lg-12" style="padding: 1%">
        <div [hidden]="!viewReport" style="text-align: center; border: 1px solid; min-width: 500px;">
            <div style="text-align: center;">{{trendBarReportTitle}}</div>
            <div #trendBarChart id="trend-bar-chart"></div>
        </div>
      </div>
    </div>
    
  </div>
</div>
